"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _moment = _interopRequireDefault(require("moment")),
    _utils = require("../../../../../../../../../utils");

require("../styles/_comment-header.scss");

function Header(a) {
  var b = a.comment,
      c = b.updatedAt,
      d = b.isResolved,
      e = b.createdByUser,
      f = a.onUpdateCheckbox,
      g = a.canResolveComment,
      h = (0, _moment["default"])(c, ["x", "YYYY-MM-DDTHH:mm:ss.sssZ"]).format("YYYY/MM/DD [at] h:mm a"),
      i = (0, _utils.getUser)(e),
      j = i.name,
      k = i.imageUrl,
      l = i.isUser;
  return _react["default"].createElement("div", {
    className: "header"
  }, _react["default"].createElement("div", {
    className: "header__profile-image-wrapper"
  }, _react["default"].createElement(_uiKit.Image, {
    height: "40px",
    width: "40px",
    imageUrl: k,
    placeholderText: j,
    placeholderTextSize: 15,
    circular: !0,
    backgroundSize: "cover"
  }), _react["default"].createElement("div", {
    className: "header__profile-image-wrapper__text"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0
  }, l ? "You" : j), _react["default"].createElement(_uiKit.Text, {
    placeholder: !0,
    noMargin: !0
  }, h))), g ? _react["default"].createElement(_uiKit.Checkbox, {
    checked: d,
    onChange: f
  }) : null);
}

var _default = (0, _react.memo)(Header);

exports["default"] = _default;